<div class="title-group">
  <h3 class='sub-title'>
    COPPA Audience
  </h3>
</div>

<div class='callout-banner'>
  <div class='callout-badge-container'>
    <div class='callout-badge'><img class='callout-badge-icon' alt='{{ targetChildrenActiveLabel }} Icon'
        [src]='targetChildrenActiveIcon' /></div>
    <div class='callout-badge-label'>{{ targetChildrenActiveLabel }}</div>

    <ng-container *ngIf="user.hasPermission( 'mrtCtvInsightsCoppaPermissionRisk' )">
      <suggest-feedback [metricPrettyName]='"Coppa Audience"' [metricId]='"coppaPermissions.targetChildrenRisk"'
        [type]='"app"' [id]='data?.coppaPermissions?.targetChildrenRisk'></suggest-feedback>
    </ng-container>
  </div>
  <div class='callout-description'>
    <ng-container *ngIf="!user.hasPermission( 'mrtCtvInsightsCoppaPermissionRisk' )">
      <div class="freemium-lock">
        <i class="fa fa-lock"></i>
      </div>
    </ng-container>
    <ng-container *ngIf="user.hasPermission( 'mrtCtvInsightsCoppaPermissionRisk' )">
      {{ targetChildrenReason }}
    </ng-container>
  </div>
</div>

<ng-container *ngIf='( bp$ | async ) >= Breakpoint.lg then audienceTwoCol else audienceOneCol'></ng-container>

<ng-template #audienceOneCol>
  <div class='info-list-container'>
    <div class='info-column'>
      <div class='info-section'>
        <info-list-item label="Category" [value]='data?.coppaPermissions?.categories[ 0 ]?.name || "N/A"'>
        </info-list-item>
        <info-list-item [show]="device == 'roku'" label="Parental Hint" [value]='data?.overview?.parentHint || "N/A"'>
        </info-list-item>
        <info-list-item [show]="device == 'firetv'" label="Age Rating" [value]='data?.overview?.ageGroup || "N/A"'>
        </info-list-item>
        <info-list-item label="Verifiable Parental Consent (VPC)" labelTooltip="{{ descriptions.vpcDetected }}"
          [value]='data?.coppaPermissions?.vpcDetected ? "Detected" : "Not Detected"'
          [valueIcon]='data?.coppaPermissions?.vpcDetected | iconMapper:"yes-check-green.svg":"no-exclamation-red.svg"'
          [show]="data?.coppaPermissions?.targetChildrenRisk == 'high' && data?.coppaPermissions?.vpcDetected != undefined && data?.coppaPermissions?.vpcDetected !== 'N/A'">
        </info-list-item>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #audienceTwoCol>
  <div class='info-list-container info-row'>
    <div class='info-column'>
      <div class='info-section'>
        <info-list-item label="Category" [value]='data?.coppaPermissions?.categories[ 0 ]?.name || "N/A"'>
        </info-list-item>
      </div>
    </div>
    <div class='info-column'>
      <div class='info-section'>
        <info-list-item [show]="device == 'roku'" label="Parental Hint" [value]='data?.appInfo?.parentalHint || "N/A"'>
        </info-list-item>
        <info-list-item [show]="device == 'firetv'" label="Age Rating" [value]='data?.appInfo?.ageGroup || "N/A"'>
        </info-list-item>
        <info-list-item label="Verifiable Parental Consent (VPC)" labelTooltip="{{ descriptions.vpcDetected }}"
          [value]='data?.coppaPermissions?.vpcDetected ? "Detected" : "Not Detected"'
          [valueIcon]='data?.coppaPermissions?.vpcDetected | iconMapper:"yes-check-green.svg":"no-exclamation-red.svg"'
          [show]="data?.coppaPermissions?.targetChildrenRisk == 'high' && data?.coppaPermissions?.vpcDetected != undefined && data?.coppaPermissions?.vpcDetected !== 'N/A'">
        </info-list-item>
      </div>
    </div>
  </div>
</ng-template>

<div class='title-group section-divider'>
  <h3 class='sub-title'>
    COPPA Violation Risk
  </h3>

  <ng-container *ngIf="user.hasPermission( 'mrtCtvInsightsCoppaPermissionRisk' ) else freemiumLock">
    <risk-heat-bar [risk]='data?.coppaPermissions?.coppaRisk' tooltip={{data?.coppaPermissions?.coppaRiskReason}}>
    </risk-heat-bar>

    <p *ngIf="( bp$ | async ) < Breakpoint.md">
      {{ data?.coppaPermissions?.coppaRiskReason }}
    </p>
  </ng-container>

  <ng-template #freemiumLock>
    <div class="freemium-lock">
      <i class="fa fa-lock"></i>
    </div>
  </ng-template>
</div>

<ng-container *ngIf='( bp$ | async ) >= Breakpoint.lg then complianceTwoCol else complianceOneCol'></ng-container>

<ng-template #complianceOneCol>
  <div class='info-list-container'>
    <div class='info-column'>
      <div class='info-section'>
        <info-list-item label="Privacy Policy" labelTooltip="{{ descriptions.privacyPolicy }}"
          [valueIcon]='data?.coppaPermissions?.privacyPolicy | iconMapper:"no-exclamation-red.svg":"yes-check-green.svg":"na-gray.svg"'
          value='{{ data?.coppaPermissions?.privacyPolicy | detectednotdetected:"capitalize":"rev" }}'>
        </info-list-item>
        <info-list-item label="Transmits Residential IP" labelTooltip="{{ descriptions.ipTraffic }}"
          [valueIcon]='data?.coppaPermissions?.ipTraffic | iconMapper:"yes-exclamation-red.svg":"no-times-green.svg":"na-gray.svg"'
          value='{{ data?.coppaPermissions?.ipTraffic | detectednotdetected:"capitalize" }}'>
        </info-list-item>
        <info-list-item label='Transmits Location' labelTooltip="{{ descriptions.passesLocation }}"
          [valueIcon]='data?.coppaPermissions?.passesLocation | iconMapper:"yes-exclamation-red.svg":"no-times-green.svg":"na-gray.svg"'
          value='{{ data?.coppaPermissions?.passesLocation | detectednotdetected:"capitalize" }}'>
        </info-list-item>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #complianceTwoCol>
  <div class='info-list-container info-row'>
    <div class='info-column'>
      <div class='info-section'>
        <info-list-item label="Privacy Policy" labelTooltip="{{ descriptions.privacyPolicy }}"
          [valueIcon]='data?.coppaPermissions?.privacyPolicy | iconMapper:"no-exclamation-red.svg":"yes-check-green.svg":"na-gray.svg"'
          value='{{ data?.coppaPermissions?.privacyPolicy | detectednotdetected:"capitalize":"rev" }}'>
        </info-list-item>
        <info-list-item label="Transmits Residential IP" labelTooltip="{{ descriptions.ipTraffic }}"
          [valueIcon]='data?.coppaPermissions?.ipTraffic | iconMapper:"yes-exclamation-red.svg":"no-times-green.svg":"na-gray.svg"'
          value='{{ data?.coppaPermissions?.ipTraffic | detectednotdetected:"capitalize" }}'>
        </info-list-item>
      </div>
    </div>
    <div class='info-column'>
      <div class='info-section'>
        <info-list-item label='Transmits Location' labelTooltip="{{ descriptions.passesLocation }}"
          [valueIcon]='data?.coppaPermissions?.passesLocation | iconMapper:"yes-exclamation-red.svg":"no-times-green.svg":"na-gray.svg"'
          value='{{ data?.coppaPermissions?.passesLocation | detectednotdetected:"capitalize" }}'>
        </info-list-item>
      </div>
    </div>
  </div>
</ng-template>

<div class="footer" *ngIf="user.hasPermission( 'mrtCtvInsightsCoppaPermissionRisk' )">
  <a href="https://www.pixalate.com/coppa-ctv-methodology" target="_blank">
    <span>Learn more about methodology
      & disclaimers</span>
    <i class='fa fa-external-link ml-1' aria-hidden='true'></i></a>
</div>